/**
 * URLs del sitio del Premio.
 *
 * Viven acá y no en cada pantalla porque ya son tres los lugares que las
 * necesitan —el listado de convocatorias, el botón de demo y los enlaces de
 * jurados—, y tres copias de la misma regla es como terminan apuntando a
 * dominios distintos.
 */

export const getPremioWebUrl = () => {
  if (process.env.REACT_APP_PREMIO_WEB_URL) {
    return process.env.REACT_APP_PREMIO_WEB_URL.replace(/\/$/, '');
  }

  const apiUrl = process.env.REACT_APP_EXTERNAL_API_BASE_URL || '';
  return apiUrl.includes('localhost')
    ? 'http://localhost:3000'
    : 'https://premio.chileconverge.cl';
};

/**
 * Ambiente demo.
 *
 * En producción es su propio subdominio. En local no hay subdominios, así que
 * se entra por la ruta con el flag, que el frontend interpreta igual.
 */
export const getPremioDemoUrl = () => {
  if (process.env.REACT_APP_PREMIO_DEMO_URL) {
    return process.env.REACT_APP_PREMIO_DEMO_URL.replace(/\/$/, '');
  }

  const base = getPremioWebUrl();
  return base.includes('localhost')
    ? `${base}/login?demo=1`
    : 'https://demo.premio.chileconverge.cl';
};

/**
 * Enlace personalizado de un jurado.
 *
 * Usa el **slug** de la convocatoria y no su id: la ruta del portal es
 * `/c/{slug}/jurados`, y para algunas convocatorias los dos valores difieren.
 * El slug lo devuelve el backend junto con el token, precisamente para no
 * tener que adivinarlo acá.
 */
export const getJuradoAccessUrl = (convocatoriaSlug, accessToken) =>
  `${getPremioWebUrl()}/c/${encodeURIComponent(convocatoriaSlug)}/jurados` +
  `?acceso=${encodeURIComponent(accessToken)}`;
